import { render, staticRenderFns } from "./InsuranceRiskPaymentConfirmFeedback.vue?vue&type=template&id=1591f7c4&scoped=true&"
import script from "./InsuranceRiskPaymentConfirmFeedback.vue?vue&type=script&lang=js&"
export * from "./InsuranceRiskPaymentConfirmFeedback.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceRiskPaymentConfirmFeedback.vue?vue&type=style&index=0&id=1591f7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591f7c4",
  null
  
)

export default component.exports